

























































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { get_agency_invoice_detail } from '@/api/invoice';
import { list_product_summaries } from '@/api/product';
import { download } from '@/api/document';
import {
  getFilenameWithoutSuffixFromDocumentUrl,
  isDocumentUrl,
  getDocumentUrl,
  formatApiError,
} from '@/utils/index';
import { AppModule } from '@/store/modules/app';

@Component({
  name: 'InvoiceAgencyDetailDocuments',
})
export default class extends Vue {
  @Prop({ default: true }) flat!: boolean;
  @Prop({ required: true }) private documentUrl!: string;
  // @Prop({ required: true })
  // private documents!: get_agency_invoice_detail.InvoiceDocument[];
  // @Prop({ required: true }) products!: Map<
  //   string,
  //   list_product_summaries.Product
  // >;

  private getURLWithProtocal(url: string) {
    if (url) {
      // if (url.startsWith('http://') || url.startsWith('https://')) {
      //   return url;
      // } else {
      //   return `http://${url}`;
      // }
      return getDocumentUrl(url);
    }
    return '';
  }

  private isDocumentUrl(url: string) {
    return isDocumentUrl(url);
  }

  private async download(url: string, newTab = true) {
    AppModule.StartProgress();

    try {
      const filename = `${getFilenameWithoutSuffixFromDocumentUrl(url)}.pdf`;
      await download(url, filename, '*/*', !newTab);
      // this.$toast.success(
      //   this.$t('Downloaded {msg}', {
      //     msg: 'PDF',
      //   }) as string,
      //   {
      //     icon: 'mdi-file-download',
      //   }
      // );
    } catch (err) {
      this.$toast.error(
        this.$t('Failed to {do} due to {err}', {
          do: (this.$t(`Download`) as string).toLowerCase(),
          err: formatApiError(this.$i18n, err),
        }) as string,
        {
          icon: 'mdi-alert',
        }
      );
    }

    AppModule.StopProgress();
  }

  // private getProductNameText(item: get_agency_invoice_detail.InvoiceDocument) {
  //   return `${
  //     this.$i18n.locale !== 'ja' &&
  //     this.products.has(item.productId) &&
  //     this.products.get(item.productId)!.nameEn
  //       ? this.products.get(item.productId)!.nameEn
  //       : item.productName
  //   }${
  //     this.products.get(item.productId)!.fiscalYear === 0
  //       ? ''
  //       : ' [' + this.products.get(item.productId)!.fiscalYear + ']'
  //   }`;
  // }
}
